import { useMemo, useState } from "react";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CREATE_NOTES, EDIT_NOTES, SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST } from "config/paths";
import { Col, Container, Row } from "react-bootstrap";
import { Breadcrumbs, CommonSelect } from "components/Common/Common";
import ReportsComponent from "./ReportsComponent";
import ClientsReportMenu from "components/shared/ReportComponents/ClientsReportMenu";
import { useGetSchoolClientDataQuery } from "store/services/clients/school.client";
import { CLIENT_STATUS_OPTION, REPORTS_FILTER_OPTIONS } from "config/constants";
import { getClientBreadCrumbs, userFullName } from "helpers/common";

const ReportsPage = ({ }) => {
    const navigate = useNavigate()
    const { clientId, moduleName, clientType } = useParams()
    const [clientDetails, setClientDetails] = useState(null)
    const [filter, setFilter] = useState({ status: "" })

    const breadcrumbItems = useMemo(() => getClientBreadCrumbs(clientId, clientType, clientDetails, "All Reports"), [clientType, clientDetails, clientId]);

    const handleFilterChange = (key) => (value) => {
        setFilter({ ...filter, [key]: value })
    };

    return (
        <>
            <section
                className={`position-relative ClientDetail`}
            >
                <Container fluid>
                    <Row style={{ paddingLeft: '12px' }} className="pt-3">
                        <Col lg="6">
                            <Breadcrumbs items={breadcrumbItems} />
                        </Col>
                    </Row>
                    <div className="mt-2">
                        <ReportsComponent setClientDetails={setClientDetails} statusFilter={filter?.status} clientId={clientId} clientType={clientType} isPage={true} />
                    </div>
                </Container>
            </section>
        </>
    );

};

export default ReportsPage;